export const PLAN_FEATURES = {
  free: {
    hideIcon:    false,
    screenTime:  false,
    bedtime:     false,
    reports:     false,
    whatsapp:    false,
    deleteSS:    false,
    maxWebsites: 20,
    maxChildren: 1,
    pdfReports:  false,
    ssInterval:  30,
    label:       'Free Forever',
    color:       '#6b7280',
  },
  trial: {
    hideIcon:    true,
    screenTime:  true,
    bedtime:     true,
    reports:     true,
    whatsapp:    true,
    deleteSS:    true,
    maxWebsites: 999999,
    maxChildren: 3,
    pdfReports:  true,
    ssInterval:  5,
    label:       '7-Day Trial',
    color:       '#d97706',
  },
  plus: {
    hideIcon:    true,
    screenTime:  true,
    bedtime:     true,
    reports:     true,
    whatsapp:    true,
    deleteSS:    true,
    maxWebsites: 999999,
    maxChildren: 1,
    pdfReports:  false,
    ssInterval:  10,
    label:       'Plus',
    color:       '#2563eb',
  },
  family: {
    hideIcon:    true,
    screenTime:  true,
    bedtime:     true,
    reports:     true,
    whatsapp:    true,
    deleteSS:    true,
    maxWebsites: 999999,
    maxChildren: 3,
    pdfReports:  true,
    ssInterval:  5,
    label:       'Family',
    color:       '#7c3aed',
  },
};

/**
 * Resolves the effective plan from a customer row.
 * - free: always free, no expiry
 * - trial: 7-day trial, expires at trial_ends_at → becomes free
 * - plus/family: paid subscription, expires at trial_ends_at → becomes free
 *
 * Returns { plan, features, isPaid, isTrial, isFree, isExpired, expiresAt, daysLeft }
 */
export function getPlanInfo(customer) {
  if (!customer) {
    return {
      plan: 'free',
      features: PLAN_FEATURES.free,
      isPaid: false,
      isTrial: false,
      isFree: true,
      isExpired: false,
      expiresAt: null,
      daysLeft: null,
      maxActiveKids: 1,
    };
  }

  const rawPlan = customer.plan || 'free';
  const expiresAt = customer.trial_ends_at ? new Date(customer.trial_ends_at) : null;
  const now = new Date();
  const isExpired = expiresAt ? expiresAt < now : false;

  // If plan has expired, effective plan is free
  const effectivePlan = (rawPlan !== 'free' && isExpired) ? 'free' : rawPlan;
  const features = PLAN_FEATURES[effectivePlan] || PLAN_FEATURES.free;

  const daysLeft = expiresAt && !isExpired
    ? Math.max(0, Math.ceil((expiresAt - now) / 86400000))
    : 0;

  return {
    plan: effectivePlan,
    rawPlan,
    features,
    isPaid: effectivePlan === 'plus' || effectivePlan === 'family',
    isTrial: effectivePlan === 'trial',
    isFree: effectivePlan === 'free',
    isExpired,
    expiresAt,
    daysLeft,
    maxActiveKids: features.maxChildren || 1,
  };
}

/**
 * Calculate new expiry date for subscription purchase/renewal.
 * If current plan is still active, extend from current expiry.
 * If expired or new, start from now.
 */
export function calculateNewExpiry(currentExpiresAt, billingCycle) {
  const now = new Date();
  const startFrom = (currentExpiresAt && new Date(currentExpiresAt) > now)
    ? new Date(currentExpiresAt)
    : now;

  if (billingCycle === 'yearly') {
    return new Date(startFrom.getTime() + 365 * 86400000);
  }
  // monthly
  return new Date(startFrom.getTime() + 30 * 86400000);
}
